var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3263",
    "data-name": "Group 3263",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.28,
    height: 38.584,
    viewBox: "0 0 40.28 38.584",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4009",
    "data-name": "Path 4009",
    d: "M96.27,0A11.218,11.218,0,1,1,85,11.166,11.178,11.178,0,0,1,96.27,0Zm0,2.609a8.529,8.529,0,0,0-8.557,8.557A8.557,8.557,0,1,0,96.27,2.609Z",
    transform: "translate(-76.13)",
    fill: "#ef4a9b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4010",
    "data-name": "Path 4010",
    d: "M14.922,221H25.358A14.965,14.965,0,0,1,40.28,235.818c0,.939-2.713.939-2.713,0a12.293,12.293,0,0,0-12.209-12.209H14.922A12.315,12.315,0,0,0,2.609,235.818c0,.939-2.609.939-2.609,0A14.9,14.9,0,0,1,14.922,221Z",
    transform: "translate(0 -197.938)",
    fill: "#ef4a9b"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.f51abf704e8c396a9ff501bfa685473c.svg";
export { ForwardRef as ReactComponent };